/**
 * Temporary diagnostics for React #301 (max update depth).
 * Logs a stack and recent React owner hints when the loop fires.
 * Remove once the my-properties crash is fixed.
 */
export function installUpdateDepthDiagnostics() {
  if (typeof window === 'undefined') return () => {}
  if (window.__hf301DiagnosticsInstalled) return () => {}
  window.__hf301DiagnosticsInstalled = true

  const isUpdateDepthError = (value) => {
    const text =
      typeof value === 'string'
        ? value
        : typeof value?.message === 'string'
          ? value.message
          : ''
    return (/Minified React error #301/i.test(text) || /Maximum update depth exceeded/i.test(text));
  }

  const logHit = (source, detail) => {
    // Keep this loud and readable — collapsed Objects were useless in the console.
    console.error(`[HF301] ${source}`, detail)
    console.error('[HF301] capture stack', new Error('HF301 probe').stack)
    try {
      console.error('[HF301] pathname', window.location.pathname)
      console.error(
        '[HF301] view/tab',
        localStorage.getItem('view'),
        'portfolio',
        localStorage.getItem('portfolio'),
        'colorMode',
        localStorage.getItem('hf-color-mode'),
      )
      console.error(
        '[HF301] lastApollo',
        window.__hfLastApolloOperation || null,
      )
    } catch (_e) {
      /* ignore */
    }
  }

  const onError = (evt) => {
    if (!isUpdateDepthError(evt?.message) && !isUpdateDepthError(evt?.error)) {
      return
    }
    logHit('window.error', {
      message: evt?.message,
      filename: evt?.filename,
      lineno: evt?.lineno,
      colno: evt?.colno,
      errorMessage: evt?.error?.message,
      errorStack: evt?.error?.stack,
    })
  }

  const onRejection = (evt) => {
    if (!isUpdateDepthError(evt?.reason)) return
    logHit('unhandledrejection', {
      reasonMessage: evt?.reason?.message || String(evt?.reason),
      reasonStack: evt?.reason?.stack,
    })
  }

  window.addEventListener('error', onError)
  window.addEventListener('unhandledrejection', onRejection)

  return () => {
    window.removeEventListener('error', onError)
    window.removeEventListener('unhandledrejection', onRejection)
    delete window.__hf301DiagnosticsInstalled
  }
}
